import { Action, ActionType } from './Action';

export const setLeftSelectedScenarioId = (id: string): Action => ({
	type: ActionType.setLeftId,
	payload: id,
});

export const setRightSelectedScenarioId = (id: string | null): Action => ({
	type: ActionType.setRightId,
	payload: id,
});
